/**
 * Shared subscribe helpers for teaser / preheat campaign forms.
 * - Quota (max 2): namespaces keep teaser and preheat counts separate.
 * - API result mapping for user_subscription responses.
 */
(function (global) {
  var MAX = 2;
  var MSG = {
    exists: 'Email exists. This address has already been submitted. Please try another email.',
    other: 'Security issue. Something went wrong on our side. Please try again later.'
  };

  function stateKey(ns, source) {
    return 'zz_campaign_' + ns + '_subscribe_state_' + source;
  }

  function readState(ns, source, legacyKeys) {
    try {
      var raw = localStorage.getItem(stateKey(ns, source));
      if (raw) {
        var parsed = JSON.parse(raw);
        if (parsed && typeof parsed.count === 'number') {
          return {
            count: Math.max(0, Math.min(MAX, parsed.count)),
            lastEmail: parsed.lastEmail || ''
          };
        }
      }
      if (legacyKeys && legacyKeys.length) {
        for (var i = 0; i < legacyKeys.length; i++) {
          var legacy = localStorage.getItem(legacyKeys[i]);
          if (legacy) {
            var migrated = { count: MAX, lastEmail: legacy };
            writeState(ns, source, migrated);
            return migrated;
          }
        }
      }
    } catch (e) {}
    return { count: 0, lastEmail: '' };
  }

  function writeState(ns, source, state) {
    try {
      localStorage.setItem(stateKey(ns, source), JSON.stringify(state));
    } catch (e) {}
  }

  /** 至少包含 @，且不能有空格 */
  function isValidEmail(email) {
    if (!email || typeof email !== 'string') return false;
    if (/\s/.test(email)) return false;
    return email.indexOf('@') !== -1;
  }

  /**
   * Map user_subscription API response.
   * Returns { ok, type } where type is 'format' | 'exists' | 'other'
   * Format copy stays section settings.error_text; exists/other use MSG.
   */
  function mapResponse(data) {
    if (!data || typeof data !== 'object') {
      return { ok: false, type: 'other' };
    }

    var code = Number(data.code);
    var message = String(data.message || '');

    if (code === 200) {
      return { ok: true };
    }

    if (code === 1001 || message === '格式错误' || /illegal email/i.test(message)) {
      return { ok: false, type: 'format' };
    }

    if (code === 1002 || message === '已存在' || /email exist/i.test(message)) {
      return { ok: false, type: 'exists' };
    }

    /* 含 IP 调用频繁(500) 等，统一走 other */
    return { ok: false, type: 'other' };
  }

  function messageForType(type, formatMessage) {
    if (type === 'format') {
      return formatMessage || 'We need your email to keep you in the loop. Please enter a valid email address.';
    }
    if (type === 'exists') return MSG.exists;
    return MSG.other;
  }

  global.ZZCampaignSubscribeQuota = {
    MAX: MAX,
    MSG: MSG,
    read: readState,
    write: writeState,
    key: stateKey,
    isValidEmail: isValidEmail,
    mapResponse: mapResponse,
    messageForType: messageForType
  };
})(window);
